module.exports = __webpack_public_path__ + "static/media/posta_Ostrava_2.fe5d3c84.jpg";